let lastAddStockFunction = null;

function animateDockVisibility(isVisible) {
  const dock = document.querySelector('#dock');
  if (!dock) return;

  const duration = 600;
  
  if (isVisible) {
    dock.setAttribute('animation__scale', {
      property: 'scale',
      to: '1.05 1.05 1.05',
      dur: duration,
      easing: 'easeInOutQuad'
    });
    dock.setAttribute('animation__position', {
      property: 'position',
      to: '-0.14 1.06 -1.75',
      dur: duration,
      easing: 'easeInOutQuad'
    });
  } else {
    dock.setAttribute('animation__scale', {
      property: 'scale',
      to: '0.001 0.001 0.001',
      dur: duration,
      easing: 'easeInOutQuad'
    });
    dock.setAttribute('animation__position', {
      property: 'position',
      to: '-0.14 -1.06 -1.75',
      dur: duration,
      easing: 'easeInOutQuad'
    });
  }
}

function addBannerAndRotationControls(bannerText, rotateControlsPosition, bannerPosition, fontSize, intervalControlPosition, dataSource) {
  const centerPanel = document.getElementById("large-center-panel");
  const centerPanelContent = document.getElementById("large-center-panel-content");
  const dock = document.getElementById("dock");

  let banner = document.getElementById("stock-banner");
  if (!banner) {
    banner = document.createElement("a-troika-text");
    banner.setAttribute("id", "stock-banner");
    banner.setAttribute("align", "center");
    banner.setAttribute("scale", "1 1 1");
    const _bannerIsLight = document.querySelector('body').classList.contains('light') || document.querySelector('body').classList.contains('cb-light');
    banner.setAttribute("color", _bannerIsLight ? "#111827" : "white");
    banner.setAttribute("depthOffset", "1");
    banner.setAttribute("outline-blur", "0.05");
    banner.setAttribute("outline-width", "0.001");
    banner.setAttribute("outline-color", _bannerIsLight ? "#FFFFFF" : "#000000");

    const mainSettings = getCacheItem('mainSettings');
    const isLightTheme = document.querySelector('body').classList.contains('light') || document.querySelector('body').classList.contains('cb-light');
    const isMobile = /(iPhone|iPad|iPod|Android|Mobi|Tablet)/i.test(navigator.userAgent);
    const quality = (mainSettings && mainSettings.quality) ? mainSettings.quality : (isMobile ? 'performance' : 'quality');
    let opacity = 1;
    if (quality === 'performance' && isLightTheme) {
      opacity = 0.3;
    }
    banner.setAttribute("outline-opacity", opacity.toString());
    
    banner.object3D.renderOrder = 999;
    banner.classList.add('billboard-y');
    centerPanelContent.appendChild(banner);
  }

  banner.setAttribute("value", bannerText);
  
  const isMmapOrNewsGraph = dataSource === 'mmap' || dataSource === 'news-graph';
  const finalBannerPosition = isMmapOrNewsGraph ? "0 0.58 0" : bannerPosition;
  banner.setAttribute("position", finalBannerPosition);
  banner.setAttribute("font-size", fontSize);

  const currentTimeAndDate = document.querySelector("#current-time-date");
  if (currentTimeAndDate) {
    currentTimeAndDate.object3D.renderOrder = 999;
    const finalDateTimePosition = isMmapOrNewsGraph ? "0 0.55 0" : "0 0.43 0";
    currentTimeAndDate.setAttribute("position", finalDateTimePosition);
  }

  setTimeout(() => {
    if (!dock) return console.warn("dock not found for rotation or interval controls");

    const targetWrapper = dataSource === 'news-graph' ? '#news-graph-wrapper' : '#stock-3d-cube-wrapper';

    const existingRotationControls = document.getElementById("rotation-controls");
    if (existingRotationControls) {
      existingRotationControls.remove();
    }
    const rotationControls = document.createElement("a-entity");
    rotationControls.setAttribute("id", "rotation-controls");
    rotationControls.setAttribute("rotation-controls", `target: ${targetWrapper}`);
    rotationControls.setAttribute("position", '0.59 -0.81 0');
    rotationControls.setAttribute("rotation", '0 0 45');
    dock.appendChild(rotationControls);

    const existingPredefinedRotationControls = document.getElementById("predefined-rotation-controls");
    if (existingPredefinedRotationControls) {
      existingPredefinedRotationControls.remove();
    }
    const predefinedRotationControls = document.createElement("a-entity");
    predefinedRotationControls.setAttribute("id", "predefined-rotation-controls");
    predefinedRotationControls.setAttribute("predefined-rotation-controls", `target: ${targetWrapper}`);
    predefinedRotationControls.setAttribute("position", '0.98 -0.49 0');
    predefinedRotationControls.setAttribute("rotation", '0 0 45');
    dock.appendChild(predefinedRotationControls);
    const existingExtraMenuButtons = document.getElementById("extra-menu-buttons");
    if (existingExtraMenuButtons) {
      existingExtraMenuButtons.remove();
    }
    const extraMenuButtons = document.createElement("a-entity");
    extraMenuButtons.setAttribute("id", "extra-menu-buttons");
    extraMenuButtons.setAttribute("extra-menu-buttons", "");
    extraMenuButtons.setAttribute("position", '-0.23 -0.88 0');
    extraMenuButtons.setAttribute("rotation", '0 0 135');
    dock.appendChild(extraMenuButtons);
    const existingIntervalControl = document.getElementById("interval-control");
    if (existingIntervalControl) {
      existingIntervalControl.remove();
    }
    const intervalControl = document.createElement("a-entity");
    intervalControl.setAttribute("id", "interval-control");
    console.log('Adding interval-control for dataSource:', dataSource);
    intervalControl.setAttribute("position", '0.08 -1.12 0.02');
    intervalControl.setAttribute("rotation", '0 0 -45');
    intervalControl.setAttribute("scale", '.1 .1 .1');
    const isIntervalSupported = !['sip', 'sip-sec', 'dividend', 'dividend-sec', 'news-graph'].includes(dataSource);
    intervalControl.setAttribute("visible", isIntervalSupported);
    intervalControl.setAttribute("data-interval-control", "");
    dock.appendChild(intervalControl);

    // // Create new chart-type-control
    // const existingChartTypeControls = document.getElementById("chart-type-control");
    // if (!existingChartTypeControls) {
    //   const chartTypeControl = document.createElement("a-entity");
    //   chartTypeControl.setAttribute("id", "chart-type-control");
    //   chartTypeControl.setAttribute("position", '1.5 0.9 0');
    //   chartTypeControl.setAttribute("scale", '.1 .1 .1');
    //   chartTypeControl.setAttribute("chart-type-control", "");
    //   dock.appendChild(chartTypeControl);
    // }

  }, 100);
}

const stockVisualizations = {
  addStockGainersToCenterPanel: {
    VR: ["stock-3d-cube", "top-gainers", "0 0 0", "0.85 0.85 0.85", "Top Gainers Percentage", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-gainers", "0 0 .5", "0.95 0.95 0.95", "Top Gainers Percentage", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-gainers", "0 0 .5", "0.95 0.95 0.95", "Top Gainers Percentage", "0 0 0", 2, 2, 2]
  },
  addStockLosersToCenterPanel: {
    VR: ["stock-3d-cube", "top-losers", "0 0 0", "0.85 0.85 0.85", "Top Losers Percentage", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-losers", "0 0 .5", "0.95 0.95 0.95", "Top Losers Percentage", "350 10 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-losers", "0 0 .5", "0.95 0.95 0.95", "Top Losers Percentage", "350 10 0", 2, 2, 2]
  },
  addStockGainersSectorToCenterPanel: {
    VR: ["stock-3d-cube", "top-gainers-sec", "0 0 0", "0.85 0.85 0.85", "Top Gainers Percentage by Sector", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-gainers-sec", "0 0 .5", "0.95 0.95 0.95", "Top Gainers Percentage by Sector", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-gainers-sec", "0 0 .5", "0.95 0.95 0.95", "Top Gainers Percentage by Sector", "0 0 0", 2, 2, 2]
  },
  addStockLosersSectorToCenterPanel: {
    VR: ["stock-3d-cube", "top-losers-sec", "0 0 0", "0.85 0.85 0.85", "Top Losers Percentage by Sector", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-losers-sec", "0 0 .5", "0.95 0.95 0.95", "Top Losers Percentage by Sector", "350 10 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-losers-sec", "0 0 .5", "0.95 0.95 0.95", "Top Losers Percentage by Sector", "350 10 0", 2, 2, 2]
  },
  addStockByVolCubeToCenterPanel: {
    VR: ["stock-3d-cube", "top-vol-sec", "0 0 0", "0.85 0.85 0.85", "Top Volume Movers by Sector - # of Shares", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-vol-sec", "-0.1 0 .5", "0.95 0.95 0.95", "Top Volume Movers by Sector - # of Shares", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-vol-sec", "-0.1 0 .5", "0.95 0.95 0.95", "Top Volume Movers by Sector - # of Shares", "0 0 0", 2, 2, 2]
  },
  addStockByVolRankCubeToCenterPanel: {
    VR: ["stock-3d-cube", "top-vol", "0 0 0", "0.85 0.85 0.85", "Top Volume Movers - # of Shares", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-vol", "-0.1 0 .5", "0.95 0.95 0.95", "Top Volume Movers - # of Shares", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-vol", "-0.1 0 .5", "0.95 0.95 0.95", "Top Volume Movers - # of Shares", "0 0 0", 2, 2, 2]
  },
  addStockTopDollarSectorCubeToCenterPanel: {
    VR: ["stock-3d-cube", "top-dollar-vol-sec", "0 0 0", "0.85 0.85 0.85", "Top Total $ Volume by Sector - Volume (Shares)", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-dollar-vol-sec", "-0.1 0 .5", "0.95 0.95 0.95", "Top Total $ Volume by Sector - Price % Change", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-dollar-vol-sec", "-0.1 0 .5", "0.95 0.95 0.95", "Top Total $ Volume by Sector - Price % Change", "0 0 0", 2, 2, 2]
  },
  addStockTopDollarCubeToCenterPanel: {
    VR: ["stock-3d-cube", "top-dollar-vol", "0 0 0", "0.85 0.85 0.85", "Top Total $ Volume - Price % Change", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "top-dollar-vol", "-0.1 0 .5", "0.95 0.95 0.95", "Top Total $ Volume - Price % Change", "30 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "top-dollar-vol", "-0.1 0 .5", "0.95 0.95 0.95", "Top Total $ Volume - Price % Change", "30 0 0", 2, 2, 2]
  },
  addDividendCubeToCenterPanel: {
    VR: ["stock-3d-cube", "dividend", "0 0 0", "0.85 0.85 0.85", "Dividend", "30 45 0", .75, .75, .75],
  },
  addDividendSectorCubeToCenterPanel: {
    VR: ["stock-3d-cube", "dividend-sec", "0 0 0", "0.85 0.85 0.85", "Dividend by Sector", "30 45 0", .75, .75, .75],
  },
  addShortInterestCubeToCenterPanel: {
    VR: ["stock-3d-cube", "sip", "0 0 0", "0.85 0.85 0.85", "Short Interest Percentage", "30 45 0", .75, .75, .75],
  },
  addShortInterestSectorCubeToCenterPanel: {
    VR: ["stock-3d-cube", "sip-sec", "0 0 0", "0.85 0.85 0.85", "Short Interest Percentage by Sector", "30 45 0", .75, .75, .75],
  },
  addMarketMapCubeToCenterPanel: {
    VR: ["stock-3d-cube", "mmap", "0 0 0", "0.9 0.9 0.9", "Market Map (S&P500)", "90 45 0", .75, .75, .75],
  },
  addWatchlistReportsCubeToCenterPanel: {
    VR: ["stock-3d-cube", "watchlist-reports", "0 0 0", "0.85 0.85 0.85", "Watchlist Reports", "30 45 0", .75, .75, .75],
    desktop: ["stock-3d-cube", "watchlist-reports", "0 0 .5", "0.95 0.95 0.95", "Watchlist Reports", "0 0 0", 2, 2, 2],
    desktopVR: ["stock-3d-cube", "watchlist-reports", "0 0 .5", "0.95 0.95 0.95", "Watchlist Reports", "0 0 0", 2, 2, 2]
  },

};

function createStockVisualizer(id, dataSource, position, scale, bannerText, rotation, width, height, depth) {
  const centerPanel = document.getElementById("large-center-panel");
  if (!centerPanel) {
    console.error("Center panel not found");
    return;
  }
  if (typeof window !== 'undefined' && window.VRNewsGraphController) {
    window.VRNewsGraphController.closeNewsGraph();
  }

  animateDockVisibility(true);

  const centerPanelContent = document.getElementById("large-center-panel-content") || centerPanel;
  const sectorSelector = document.getElementById("sector-selector");
  const timelineSelector = document.getElementById("timeline");
  const volDataSources = ['top-vol-sec', 'top-vol', 'top-dollar-vol', 'top-dollar-vol-sec'];
  const dataInterval = getCacheItem('data-interval');

  const visualizerConfig = {
    dataSource,
    selector: sectorSelector ? "#sector-selector" : null,
    timelineEntity: timelineSelector ? "#timeline" : null,
    interval: dataInterval ? dataInterval.toLowerCase() : null,
    ...(volDataSources.includes(dataSource) && { timelineEntity: timelineSelector ? "#timeline" : null })
  };

  try {
    const sectorsControl = document.querySelector('#sectors-control');
    let gotFromComponent = false;
    if (sectorsControl) {
      const attr = sectorsControl.getAttribute('sectors-control');
      if (attr && attr.sectorsBreaks) {
        const isDefault = Array.isArray(attr.activeSectorIDs) && attr.activeSectorIDs.length === 11;
        if (!isDefault || attr.sectorsDepth !== 6) {
          visualizerConfig.topN = attr.sectorsDepth;
          visualizerConfig.sectorIds = attr.activeSectorIDs;
          gotFromComponent = true;
        }
      }
    }
    if (!gotFromComponent && typeof getCacheItem !== 'undefined') {
      let cacheAction = 'topdollar';
      const cachedChartType = getCacheItem('lastChartType');
      if (cachedChartType && typeof cachedChartType === 'string' && cachedChartType.includes(':')) {
        cacheAction = cachedChartType.split(':')[0] || 'topdollar';
      }
      const cachedState = getCacheItem(`segments_state_${cacheAction}`);
      if (cachedState) {
        const state = typeof cachedState === 'string' ? JSON.parse(cachedState) : cachedState;
        if (state.activeSectorIDs) {
          visualizerConfig.sectorIds = state.activeSectorIDs;
        }
        if (state.sectorsDepth) {
          visualizerConfig.topN = state.sectorsDepth;
        }
      }
    }
  } catch (e) {
    console.warn('[StockCubePlacements] Failed to sync selection from sectors-control', e);
  }

  let stockCube = document.getElementById(id);
  let wrapper = document.getElementById(`${id}-wrapper`);

  if (!stockCube || !wrapper) {
    console.warn("Create new wrapper and cube", visualizerConfig);

    wrapper = document.createElement("a-box");
    wrapper.setAttribute("id", `${id}-wrapper`);
    wrapper.setAttribute("width", width);
    wrapper.setAttribute("height", height);
    wrapper.setAttribute("depth", depth);
    wrapper.setAttribute("material", `opacity: 0; transparent: true; side: double;  depthTest: false`);
    wrapper.setAttribute("position", position);
    wrapper.setAttribute("rotation", rotation || "0 0 0");
    centerPanelContent.appendChild(wrapper);

    const zeroPlane = document.createElement('a-plane');
    zeroPlane.setAttribute('id', `zero-plane`);
    zeroPlane.setAttribute('position', '0 0.001 0');
    zeroPlane.setAttribute('rotation', '-90 0 0');
    zeroPlane.setAttribute('width', '0.65');
    zeroPlane.setAttribute('height', '0.4');
    const color = document.querySelector('body').classList.contains('light') ? '#fff' : '#666';
    zeroPlane.setAttribute('material', `color: ${color}; side: double; transparent: true; opacity: 0.7; depthTest: true; depthWrite: false`);
    wrapper.appendChild(zeroPlane);
    
    stockCube = document.createElement("a-box");
    stockCube.setAttribute("id", id);
    stockCube.setAttribute("position", "0 0 0");
    stockCube.setAttribute("stock-cube-visualizer", visualizerConfig);
    stockCube.setAttribute("scale", scale);
    stockCube.setAttribute("material", `opacity: 0; transparent: true; side: double;  depthTest: true; depthWrite: false`);
    stockCube.setAttribute("width", width);
    stockCube.setAttribute("height", height);
    stockCube.setAttribute("depth", depth);
    wrapper.appendChild(stockCube);

    if (sectorSelector) {
      sectorSelector.setAttribute("sector-selector", { target: stockCube });
    }
  } else {
    console.warn("Update existing wrapper and cube", visualizerConfig);
    stockCube.setAttribute("stock-cube-visualizer", visualizerConfig);
    stockCube.setAttribute("position", "0 0 0");
    stockCube.setAttribute("scale", scale);
    stockCube.setAttribute("material", "wireframe: true; color: #fff");
    stockCube.setAttribute("width", width);
    stockCube.setAttribute("height", height);
    stockCube.setAttribute("depth", depth);
    if (wrapper) {
      wrapper.setAttribute("position", position);
      wrapper.setAttribute("rotation", rotation || "0 0 0");
      wrapper.setAttribute("scale", "1 1 1");
    }
    const newsGraphWrapper = document.getElementById('news-graph-wrapper');
    if (newsGraphWrapper) {
      newsGraphWrapper.remove();
    }
    const legendPanel = document.getElementById('news-graph-legend-vr');
    if (legendPanel) {
      legendPanel.remove();
    }
    const zeroPlane = document.querySelector('#zero-plane');
    if (zeroPlane) {
      zeroPlane.setAttribute('visible', true);
    }
    if (sectorSelector) {
      sectorSelector.setAttribute("sector-selector", { target: stockCube });
    }
  }

  addBannerAndRotationControls(
    bannerText,
    "0.0 45 0",
    "0 .46 0",
    "0.023",
    "0 0 0.02",
    dataSource
  );

  if (centerPanel) {
    const isMarketMap = dataSource === 'mmap';
    centerPanel.emit('market-map-visualizer-change', { isActive: isMarketMap }, false);
  }
}

function addStockGainersToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockGainersToCenterPanel[platform]);
  lastAddStockFunction = addStockGainersToCenterPanel;
}

function addStockLosersToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockLosersToCenterPanel[platform]);
  lastAddStockFunction = addStockLosersToCenterPanel;
}

function addStockGainersSectorToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockGainersSectorToCenterPanel[platform]);
  lastAddStockFunction = addStockGainersSectorToCenterPanel;
}

function addStockLosersSectorToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockLosersSectorToCenterPanel[platform]);
  lastAddStockFunction = addStockLosersSectorToCenterPanel;
}

function addStockByVolCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockByVolCubeToCenterPanel[platform]);
  lastAddStockFunction = addStockByVolCubeToCenterPanel;
}

function addStockByVolRankCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockByVolRankCubeToCenterPanel[platform]);
  lastAddStockFunction = addStockByVolRankCubeToCenterPanel;
}

function addStockTopDollarCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockTopDollarCubeToCenterPanel[platform]);
  lastAddStockFunction = addStockTopDollarCubeToCenterPanel;
}

function addStockTopDollarSectorCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addStockTopDollarSectorCubeToCenterPanel[platform]);
  lastAddStockFunction = addStockTopDollarSectorCubeToCenterPanel;
}

function addDividendCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addDividendCubeToCenterPanel[platform]);
  lastAddStockFunction = addDividendCubeToCenterPanel;
}

function addDividendSectorCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addDividendSectorCubeToCenterPanel[platform]);
  lastAddStockFunction = addDividendSectorCubeToCenterPanel;
}

function addShortInterestCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addShortInterestCubeToCenterPanel[platform]);
  lastAddStockFunction = addShortInterestCubeToCenterPanel;
}
function addShortInterestSectorCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addShortInterestSectorCubeToCenterPanel[platform]);
  lastAddStockFunction = addShortInterestSectorCubeToCenterPanel;
}

function addMarketMapCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addMarketMapCubeToCenterPanel[platform]);
  lastAddStockFunction = addMarketMapCubeToCenterPanel;
}

function addMyPortfolioSectorCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addMyPortfolioSectorCubeToCenterPanel[platform]);
  lastAddStockFunction = addMyPortfolioSectorCubeToCenterPanel;
}

function addWatchlistReportsCubeToCenterPanel() {
  const platform = 'VR'
  createStockVisualizer(...stockVisualizations.addWatchlistReportsCubeToCenterPanel[platform]);
  lastAddStockFunction = addWatchlistReportsCubeToCenterPanel;

  const timeline = document.getElementById('timeline');
  const watchlistDockButtons = document.getElementById('watchlist-dock-buttons');
  if (timeline) {
    timeline.setAttribute('position', '-0.370 -0.430 0');
  }
  if (watchlistDockButtons) {
    watchlistDockButtons.setAttribute('visible', true);
    watchlistDockButtons.setAttribute('scale', '0.6 0.6 0.6');
  }
}

function addNewsGraphToCenterPanel() {
  if (typeof window !== 'undefined' && window.VRNewsGraphController) {
    window.VRNewsGraphController.openNewsGraph();
  } else {
    console.warn("VRNewsGraphController not found!");
  }
  lastAddStockFunction = addNewsGraphToCenterPanel;
}

if (typeof window !== 'undefined') {
  window.animateDockVisibility = animateDockVisibility;
  window.addBannerAndRotationControls = addBannerAndRotationControls;
  window.createStockVisualizer = createStockVisualizer;
  window.addStockGainersToCenterPanel = addStockGainersToCenterPanel;
  window.addStockLosersToCenterPanel = addStockLosersToCenterPanel;
  window.addStockGainersSectorToCenterPanel = addStockGainersSectorToCenterPanel;
  window.addStockLosersSectorToCenterPanel = addStockLosersSectorToCenterPanel;
  window.addStockByVolCubeToCenterPanel = addStockByVolCubeToCenterPanel;
  window.addStockByVolRankCubeToCenterPanel = addStockByVolRankCubeToCenterPanel;
  window.addStockTopDollarCubeToCenterPanel = addStockTopDollarCubeToCenterPanel;
  window.addStockTopDollarSectorCubeToCenterPanel = addStockTopDollarSectorCubeToCenterPanel;
  window.addDividendCubeToCenterPanel = addDividendCubeToCenterPanel;
  window.addDividendSectorCubeToCenterPanel = addDividendSectorCubeToCenterPanel;
  window.addShortInterestCubeToCenterPanel = addShortInterestCubeToCenterPanel;
  window.addShortInterestSectorCubeToCenterPanel = addShortInterestSectorCubeToCenterPanel;
  window.addMarketMapCubeToCenterPanel = addMarketMapCubeToCenterPanel;
  window.addMyPortfolioSectorCubeToCenterPanel = addMyPortfolioSectorCubeToCenterPanel;
  window.addWatchlistReportsCubeToCenterPanel = addWatchlistReportsCubeToCenterPanel;
  window.addNewsGraphToCenterPanel = addNewsGraphToCenterPanel;
  window.addStockChartToRightPanel = addStockChartToRightPanel;
}

function _hideWatchlistDock() {
  const timeline = document.getElementById('timeline');
  const watchlistDockButtons = document.getElementById('watchlist-dock-buttons');
  if (timeline) {
    timeline.setAttribute('position', '-0.5 -0.56 0.01');
  }
  if (watchlistDockButtons) {
    watchlistDockButtons.setAttribute('visible', false);
    watchlistDockButtons.setAttribute('scale', '0 0 0');
  }
}

function renderStockChartByAction(action, secondaryAction = 'gen') {
  if (action !== 'watchlist-reports') {
    _hideWatchlistDock();
  }
  if (action === 'gainers') {
    if (secondaryAction === 'sec') addStockGainersSectorToCenterPanel();
    else addStockGainersToCenterPanel();
  } else if (action === 'losers') {
    if (secondaryAction === 'sec') addStockLosersSectorToCenterPanel();
    else addStockLosersToCenterPanel();
  } else if (action === 'topvol') {
    if (secondaryAction === 'sec') addStockByVolCubeToCenterPanel();
    else addStockByVolRankCubeToCenterPanel();
  } else if (action === 'topdollar') {
    if (secondaryAction === 'sec') addStockTopDollarSectorCubeToCenterPanel();
    else addStockTopDollarCubeToCenterPanel();
  } else if (action === 'sip') {
    if (secondaryAction === 'sec') addShortInterestSectorCubeToCenterPanel();
    else addShortInterestCubeToCenterPanel();
  } else if (action === 'dividend') {
    if (secondaryAction === 'sec') addDividendSectorCubeToCenterPanel();
    else addDividendCubeToCenterPanel();
  } else if (action === 'mmap') {
    addMarketMapCubeToCenterPanel();
  } else if (action === 'watchlist-reports') {
    addWatchlistReportsCubeToCenterPanel();
  } else if (action === 'news-graph') {
    addNewsGraphToCenterPanel();
  } else {
    addStockTopDollarSectorCubeToCenterPanel();
  }
}
if (typeof window !== 'undefined') {
  window.renderStockChartByAction = renderStockChartByAction;
}

function addStockChartToRightPanel(stockSymbol) {
  console.log('addStockChartToRightPanel0',)
  const rightPanel = document.getElementById("right-container");
  if (!rightPanel) {
    console.error("Right panel not found");
    return;
  }

  let stockChart = document.getElementById("stock-chart");
  if (stockChart) {
    stockChart.remove();
  }

  const newStockChart = document.createElement("a-entity");
  newStockChart.setAttribute("id", "stock-chart");
  newStockChart.setAttribute("position", "-1.5 -1 0");
  newStockChart.setAttribute("scale", "0.75 0.75 0.75");
  const storedChartType = getStoredChartType();
  console.log('Using stored chart type:', storedChartType);

  const chartComponent = document.createElement("a-entity");
  chartComponent.setAttribute("id", "stock-chart-component");
  chartComponent.setAttribute("position", "0 0 0");

  if (storedChartType === 'Candlestick') {
    chartComponent.setAttribute("stock-candlestick-chart", {
      intervals: 100,
      stockSymbol
    });
  } else if (storedChartType === 'Line') {
    chartComponent.setAttribute("tradingview-universal-chart", {
      stockData: JSON.stringify({ ticker: stockSymbol }),
      dataInterval: "1d",
      type: 'line'
    });
  } else {
    chartComponent.setAttribute("tradingview-universal-chart", {
      stockData: JSON.stringify({ ticker: stockSymbol }),
      dataInterval: "1d",
      type: 'mountain'
    });
  }

  console.log('chartComponent', chartComponent)

  newStockChart.appendChild(chartComponent);
  rightPanel.appendChild(newStockChart);

  // const rightPanelContent = document.getElementById("large-right-panel-content");
  // if (rightPanelContent) {
  //   // Add the chart component to the stock chart container
  //   newStockChart.appendChild(chartComponent);
  //   // Add the stock chart container to the panel
  //   rightPanelContent.appendChild(newStockChart);
  // }
}

function getStoredChartType() {
  try {
    const raw = localStorage.getItem('rightConfigurePopupSettings');
    console.log('Raw localStorage data:', raw);
    if (!raw) {
      console.log('No stored settings found, using default Mountain');
      return 'Mountain';
    }
    const settings = JSON.parse(raw);
    console.log('Parsed settings:', settings);
    const chartType = settings.chartType || 'Mountain';
    console.log('Using chart type:', chartType);
    return chartType;
  } catch (e) {
    console.warn('Failed to load stored chart type, using default:', e);
    return 'Mountain';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const scene = document.querySelector('a-scene');
  if (scene) {
    scene.addEventListener('app-state-changed', () => {
      if (lastAddStockFunction) {
        console.log('App state changed, re-running:', lastAddStockFunction.name);
        lastAddStockFunction();
      } else {
        console.warn('No last addStock function to re-run');
      }
    });

    const onSceneLoaded = () => {
      try {
        const cached = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
        if (cached && cached.includes(':')) {
          let [prime, secondary] = cached.split(':');
          
          try {
            const sectorsKey = `segments_state_${prime}`;
            const cachedSectors = typeof getCacheItem !== 'undefined' ? getCacheItem(sectorsKey) : null;
            if (cachedSectors) {
              const sectorsState = JSON.parse(cachedSectors);
              secondary = sectorsState.sectorsBreaks ? 'sec' : 'gen';
            }
          } catch (e) {
            console.warn('[StockCubePlacements] Failed to sync initial secondary action', e);
          }

          const sectorsControl = document.querySelector('#sectors-control');
          if (sectorsControl && sectorsControl.components['sectors-control']) {
              console.log('[StockCubePlacements] Forcing sector state load for initial chart:', prime);
              sectorsControl.components['sectors-control'].loadState(prime);
          }

          renderStockChartByAction(prime, secondary);
        } else {
          addStockTopDollarSectorCubeToCenterPanel('top-dollar-vol-sec');
        }
      } catch (e) {
        console.warn('[StockCubePlacements] Failed to initialize with cached chart type', e);
        addStockTopDollarSectorCubeToCenterPanel('top-dollar-vol-sec');
      }
    };

    if (scene.hasLoaded) {
      onSceneLoaded();
    } else {
      scene.addEventListener('loaded', onSceneLoaded, { once: true });
    }

  } else {
    document.addEventListener('loaded', () => {
      const newScene = document.querySelector('a-scene');
      if (newScene) {
        newScene.addEventListener('app-state-changed', () => {
          if (lastAddStockFunction) {
            console.log('App state changed, re-running:', lastAddStockFunction.name);
            lastAddStockFunction();
          } else {
            console.warn('No last addStock function to re-run');
          }
        });
        
        const onSceneLoaded = () => {
          try {
          const cached = typeof getCacheItem !== 'undefined' ? getCacheItem('lastChartType') : null;
          if (cached && cached.includes(':')) {
            let [prime, secondary] = cached.split(':');
            
            try {
              const sectorsKey = `segments_state_${prime}`;
              const cachedSectors = typeof getCacheItem !== 'undefined' ? getCacheItem(sectorsKey) : null;
              if (cachedSectors) {
                const sectorsState = JSON.parse(cachedSectors);
                secondary = sectorsState.sectorsBreaks ? 'sec' : 'gen';
              }
            } catch (e) {
              console.warn('[StockCubePlacements] Failed to sync initial secondary action', e);
            }
          const sectorsControl = document.querySelector('#sectors-control');
          if (sectorsControl && sectorsControl.components['sectors-control']) {
              console.log('[StockCubePlacements] Forcing sector state load for initial chart:', prime);
              sectorsControl.components['sectors-control'].loadState(prime);
          }

          renderStockChartByAction(prime, secondary);
          } else {
            addStockTopDollarSectorCubeToCenterPanel('top-dollar-vol-sec');
          }
          } catch (e) {
            console.warn('[StockCubePlacements] Failed to initialize with cached chart type', e);
            addStockTopDollarSectorCubeToCenterPanel('top-dollar-vol-sec');
          }
        };
        onSceneLoaded();
      }
    }, { once: true });
  }
});
